function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/button/buttonview
 */
import View from '../view';
import IconView from '../icon/iconview';
import TooltipView from '../tooltip/tooltipview';
import uid from '@ckeditor/ckeditor5-utils/src/uid';
import { getEnvKeystrokeText } from '@ckeditor/ckeditor5-utils/src/keyboard';
import '../../theme/components/button/button.css';
/**
 * The button view class.
 *
 *		const view = new ButtonView();
 *
 *		view.set( {
 *			label: 'A button',
 *			keystroke: 'Ctrl+B',
 *			tooltip: true,
 *			withText: true
 *		} );
 *
 *		view.render();
 *
 *		document.body.append( view.element );
 *
 * @extends module:ui/view~View
 * @implements module:ui/button/button~Button
 */

var ButtonView = /*#__PURE__*/function (_View) {
  _inherits(ButtonView, _View);

  var _super = _createSuper(ButtonView);

  /**
   * @inheritDoc
   */
  function ButtonView(locale) {
    var _this;

    _classCallCheck(this, ButtonView);

    _this = _super.call(this, locale);
    var bind = _this.bindTemplate;
    var ariaLabelUid = uid(); // Implement the Button interface.

    _this.set('class');

    _this.set('labelStyle');

    _this.set('icon');

    _this.set('isEnabled', true);

    _this.set('isOn', false);

    _this.set('isVisible', true);

    _this.set('isToggleable', false);

    _this.set('keystroke');

    _this.set('label');

    _this.set('tabindex', -1);

    _this.set('tooltip');

    _this.set('tooltipPosition', 's');

    _this.set('type', 'button');

    _this.set('withText', false);

    _this.set('withKeystroke', false);
    /**
     * Collection of the child views inside of the button {@link #element}.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */


    _this.children = _this.createCollection();
    /**
     * Tooltip of the button view. It is configurable using the {@link #tooltip tooltip attribute}.
     *
     * @readonly
     * @member {module:ui/tooltip/tooltipview~TooltipView} #tooltipView
     */

    _this.tooltipView = _this._createTooltipView();
    /**
     * Label of the button view. It is configurable using the {@link #label label attribute}.
     *
     * @readonly
     * @member {module:ui/view~View} #labelView
     */

    _this.labelView = _this._createLabelView(ariaLabelUid);
    /**
     * The icon view of the button. Will be added to {@link #children} when the
     * {@link #icon icon attribute} is defined.
     *
     * @readonly
     * @member {module:ui/icon/iconview~IconView} #iconView
     */

    _this.iconView = new IconView();

    _this.iconView.extendTemplate({
      attributes: {
        class: 'ck-button__icon'
      }
    });
    /**
     * A view displaying the keystroke of the button next to the {@link #labelView label}.
     * Added to {@link #children} when the {@link #withKeystroke `withKeystroke` attribute}
     * is defined.
     *
     * @readonly
     * @member {module:ui/view/view~View} #keystrokeView
     */


    _this.keystrokeView = _this._createKeystrokeView();
    /**
     * Tooltip of the button bound to the template.
     *
     * @see #tooltip
     * @see #_getTooltipString
     * @private
     * @observable
     * @member {Boolean} #_tooltipString
     */

    _this.bind('_tooltipString').to(_assertThisInitialized(_this), 'tooltip', _assertThisInitialized(_this), 'label', _assertThisInitialized(_this), 'keystroke', _this._getTooltipString.bind(_assertThisInitialized(_this)));

    _this.setTemplate({
      tag: 'button',
      attributes: {
        class: ['ck', 'ck-button', bind.to('class'), bind.if('isEnabled', 'ck-disabled', function (value) {
          return !value;
        }), bind.if('isVisible', 'ck-hidden', function (value) {
          return !value;
        }), bind.to('isOn', function (value) {
          return value ? 'ck-on' : 'ck-off';
        }), bind.if('withText', 'ck-button_with-text'), bind.if('withKeystroke', 'ck-button_with-keystroke')],
        type: bind.to('type', function (value) {
          return value ? value : 'button';
        }),
        tabindex: bind.to('tabindex'),
        'aria-labelledby': "ck-editor__aria-label_".concat(ariaLabelUid),
        'aria-disabled': bind.if('isEnabled', true, function (value) {
          return !value;
        }),
        'aria-pressed': bind.to('isOn', function (value) {
          return _this.isToggleable ? String(value) : false;
        })
      },
      children: _this.children,
      on: {
        mousedown: bind.to(function (evt) {
          evt.preventDefault();
        }),
        click: bind.to(function (evt) {
          // We can't make the button disabled using the disabled attribute, because it won't be focusable.
          // Though, shouldn't this condition be moved to the button controller?
          if (_this.isEnabled) {
            _this.fire('execute');
          } else {
            // Prevent the default when button is disabled, to block e.g.
            // automatic form submitting. See ckeditor/ckeditor5-link#74.
            evt.preventDefault();
          }
        })
      }
    });

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ButtonView, [{
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(ButtonView.prototype), "render", this).call(this);

      if (this.icon) {
        this.iconView.bind('content').to(this, 'icon');
        this.children.add(this.iconView);
      }

      this.children.add(this.tooltipView);
      this.children.add(this.labelView);

      if (this.withKeystroke) {
        this.children.add(this.keystrokeView);
      }
    }
    /**
     * Focuses the {@link #element} of the button.
     */

  }, {
    key: "focus",
    value: function focus() {
      this.element.focus();
    }
    /**
     * Creates a {@link module:ui/tooltip/tooltipview~TooltipView} instance and binds it with button
     * attributes.
     *
     * @private
     * @returns {module:ui/tooltip/tooltipview~TooltipView}
     */

  }, {
    key: "_createTooltipView",
    value: function _createTooltipView() {
      var tooltipView = new TooltipView();
      tooltipView.bind('text').to(this, '_tooltipString');
      tooltipView.bind('position').to(this, 'tooltipPosition');
      return tooltipView;
    }
    /**
     * Creates a label view instance and binds it with button attributes.
     *
     * @private
     * @param {String} ariaLabelUid The aria label UID.
     * @returns {module:ui/view~View}
     */

  }, {
    key: "_createLabelView",
    value: function _createLabelView(ariaLabelUid) {
      var labelView = new View();
      var bind = this.bindTemplate;
      labelView.setTemplate({
        tag: 'span',
        attributes: {
          class: ['ck', 'ck-button__label'],
          style: bind.to('labelStyle'),
          id: "ck-editor__aria-label_".concat(ariaLabelUid)
        },
        children: [{
          text: this.bindTemplate.to('label')
        }]
      });
      return labelView;
    }
    /**
     * Creates a view that displays a keystroke next to a {@link #labelView label }
     * and binds it with button attributes.
     *
     * @private
     * @returns {module:ui/view~View}
     */

  }, {
    key: "_createKeystrokeView",
    value: function _createKeystrokeView() {
      var keystrokeView = new View();
      keystrokeView.setTemplate({
        tag: 'span',
        attributes: {
          class: ['ck', 'ck-button__keystroke']
        },
        children: [{
          text: this.bindTemplate.to('keystroke', function (text) {
            return getEnvKeystrokeText(text);
          })
        }]
      });
      return keystrokeView;
    }
    /**
     * Gets the text for the {@link #tooltipView} from the combination of
     * {@link #tooltip}, {@link #label} and {@link #keystroke} attributes.
     *
     * @private
     * @see #tooltip
     * @see #_tooltipString
     * @param {Boolean|String|Function} tooltip Button tooltip.
     * @param {String} label Button label.
     * @param {String} keystroke Button keystroke.
     * @returns {String}
     */

  }, {
    key: "_getTooltipString",
    value: function _getTooltipString(tooltip, label, keystroke) {
      if (tooltip) {
        if (typeof tooltip == 'string') {
          return tooltip;
        } else {
          if (keystroke) {
            keystroke = getEnvKeystrokeText(keystroke);
          }

          if (tooltip instanceof Function) {
            return tooltip(label, keystroke);
          } else {
            return "".concat(label).concat(keystroke ? " (".concat(keystroke, ")") : '');
          }
        }
      }

      return '';
    }
  }]);

  return ButtonView;
}(View);

export { ButtonView as default };